import React, { useState, useEffect, useRef } from "react";
import { Select, MenuItem, Typography } from "@material-ui/core";
import { getAndroidAppList } from "@/apis/apiCollection";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";

const Version = ({ data, value, onChange, appIndex }) => {
  const [options, setOptions] = useState(() => {
    return [data].map(v => ({ ...v, title: v.version, value: v.version }));
  });
  const [tip, setTip] = useState(false);
  const appsRef = useRef([]);

  const { t } = useTranslation();

  const handleChange = e => {
    const row = appsRef.current.find(v => v.version === e.target.value);
    // if (row.version_code && data.version_code) {
    //   if (Number(data.version_code > row.version_code)) {
    //     setTip(true);
    //   }
    // }
    onChange({
      target: {
        name: `application.applications[${appIndex}]`,
        value: {
          id: row.id,
          name: row.package_name,
          version: row.version,
          upload_at: row.uploaded_at,
          size: row.size,
          deleted_old: false,
          file_path: row.s3_path,
          md5: row.md5,
          package_id: row.package_id,
          version_code: row.version_code
        }
      }
    });
  };

  useEffect(() => {
    getAndroidAppList({
      columns: [{ data: "version_code" }],
      target: "windows",
      parent_id: data.id,
      order: [{ column: 0, dir: "desc" }]
    }).then(({ data: res }) => {
      setOptions(
        [data, ...res].map(v => ({ title: v.version, value: v.version }))
      );
      appsRef.current = [data, ...res];
    });
  }, []);

  return (
    <>
      <Select value={value} onChange={handleChange} fullWidth>
        {options.map(option => {
          return (
            <MenuItem key={option.value} value={option.value}>
              {option.title}
            </MenuItem>
          );
        })}
      </Select>
      {tip && (
        <Modal
          open={tip}
          title={t({ defaultMessage: "提示" })}
          showCancel={false}
          onClose={() => setTip(false)}
          onConfirm={() => setTip(false)}
          width={576}
        >
          <Typography variant="body1">
            {t({
              defaultMessage:
                "当前选择的应用版本低于已存在的应用，可能会造成应用程序安装失败，请确认应用是否选择正确，如需安装较低版本的应用，可勾选删除原程序后再安装。"
            })}
          </Typography>
        </Modal>
      )}
    </>
  );
};

export default Version;
